import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { rgba } from 'polished';
import { Link } from 'react-router-dom'
import SimpleReactValidator from 'simple-react-validator';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector'
import axios from 'axios'

import { SERVER_URL } from '../../constants'
import { InputEmail, InputText, InputFile, Checkbox } from '../../components'

import ArrowDownIcon from 'svg-react-loader?name=Icon!../../assets/icons/arrow-down-black.svg';
import ArrowRight from 'svg-react-loader?name=Icon!../../assets/icons/submit-arrow.svg';

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding } from '../../styles/global';
import { media } from '../../styles/utils';
import Multiselect from '../../components/Multiselect/Multiselect';

const disciplines = [
    { value: 'illustration', label: 'Illustration' },
    { value: 'film', label: 'Film' },
    { value: 'lettering', label: 'Lettering' },
    { value: 'graphic-design', label: 'Graphic Design' },
    { value: 'web-design', label: 'Web Design' },
    { value: '3d', label: '3D' },
]

class PledgeForm extends Component{

    constructor(props){
        super(props)
        this.validator = new SimpleReactValidator()
    }

    state = {
        name: '',
        email: '',
        business: '',
        disciplines: [],
        country: 'Australia',
        city: '',
        url: '',
        file: '',
        submitDisabled: true,
        formComplete: false,
        formError: false
    }


    componentWillUpdate = (nextProps, nextState) => {
        if(this.props.userPledged != nextProps.userPledged){
            this.setState({submitDisabled: !nextProps.userPledged })
        }
    }

    handleFieldChange = (key, value) => {
        this.setState({ [key]: value })
    }

    handleFileChange = (file) => {
        this.setState({ file: file })
    }

    onCheckBoxChange = (val) => {
        console.log('onCheckBoxChange',val);
        this.setState({display: val})
    }

    handleSubmit = () => {

        const { type } = this.props;

         // Validate 

         let passedValidation = false;
         const self = this;

         passedValidation = this.validator.allValid()

         if (!passedValidation) {
             // Did not pass Validation

             this.validator.showMessages()
             this.forceUpdate()

        } else {

            this.setState({submitDisabled: false})

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            
            const formData = new FormData();

            // test for HTTP

            let url = this.state.url;

            if (url !== '') {
                url = !/^https?:\/\//i.test(url) ? `http://${url}` : url;
            }

            formData.append('file', this.state.file)
            formData.append('type', type)
            formData.append('name', this.state.name)
            formData.append('business', this.state.business)
            formData.append('email', this.state.email)
            formData.append('url', url) 
            formData.append('country', this.state.country)
            formData.append('city', this.state.city)
            formData.append('disciplines', JSON.stringify(this.state.disciplines))

            axios.post(SERVER_URL+'/wpapi/pledgefile',formData,config)
                .then(response => {

                    //console.log('response',response);
                    if(response.data){
                        this.setState({
                            formComplete: true
                        })

                    } else {
                        this.setState({
                            formError: true
                        })
                    }    

                })
                .catch(error => {
                    // console.log('error',error);
                })
  
        }
    }


    render() {
        const { formComplete, submitDisabled, formError } = this.state;
        //console.log(this.state)

        this.validator.purgeFields();

        return (
            <Wrapper>
                {(!formComplete || formError) && (
                    <Form>
                        <Title>Enter your details</Title>
                        <DownArrow />

                        <Fields>

                            <Field>
                                <InputText 
                                    label="Name *"
                                    name="name"
                                    value={this.state.name}
                                    onChangeValue={(e) => this.handleFieldChange('name', e.target.value)}
                                />
                                {this.validator.message('Name', this.state.name, 'required')}
                            </Field>

                            <Field>
                                <InputText 
                                    label="Business Name (optional)"
                                    name="business"
                                    value={this.state.business}
                                    onChangeValue={(e) => this.handleFieldChange('business', e.target.value)}
                                />
                            </Field>
                                
                            

                            <Field>
                                <InputEmail 
                                    label="Email Address **"
                                    name="email"
                                    value={this.state.email}
                                    onChangeValue={(e) => this.handleFieldChange('email', e.target.value)}
                                />
                                {this.validator.message('Email', this.state.email, 'required|email')}
                            </Field>
                            
                            <Field>
                                <Multiselect 
                                    label="Discipline *"
                                    name="disciplines"
                                    options={disciplines}
                                    value={this.state.disciplines}
                                    placeholder={'Select or type your own'}
                                    onChangeValue={(value) => this.handleFieldChange('disciplines',value)}
                                />
                                {this.validator.message('Disciplines', this.state.disciplines, 'required')}
                            </Field>


                            <Field>
                                <SelectContainer>
                                    <Label>Country *</Label>
                                    <CountryDropdown
                                        value={this.state.country}
                                        //whitelist={['AU']} //,'NZ','US'
                                        showDefaultOption={true}
                                        classes={'dropdown'}
                                        onChange={(val) => this.handleFieldChange('country', val)}
                                    />
                                    <SelectMarker>↓</SelectMarker>
                                </SelectContainer>     
                                {this.validator.message('Country', this.state.country, 'required')}   
                            </Field>
                            

                            <Field>
                                <InputText 
                                    label="Suburb / City *"
                                    name="city"
                                    value={this.state.city}    
                                    onChangeValue={(e) => this.handleFieldChange('city', e.target.value)}
                                />
                                {this.validator.message('City', this.state.city, 'required')}
                            </Field>

                            <Field>
                                <InputText 
                                    label="URL (optional)" 
                                    name="url"
                                    value={this.state.url}
                                    onChangeValue={(e) => this.handleFieldChange('url', e.target.value)}
                                />
                            </Field>


                            <Field
                                //margin={true}
                            >
                                <InputFile
                                    label="Logo or Headshot* (512x512 please)" 
                                    name="file"
                                    value={this.state.file}
                                    onChangeValue={(e) => this.handleFileChange(e.target.files[0])}
                                />  

                                {this.validator.message('Logo', this.state.file, 'required')}
                            </Field> 
                            

                            <SubmitButton
                                onClick={() => !submitDisabled && this.handleSubmit()}
                                disabled={submitDisabled}
                            >
                                <Label>SUBMIT</Label>
                                <ArrowRight />
                                <Tooltip
                                    className={'tooltip'}
                                >
                                    You'll need to tick off all pledge statements and fill out all required form fields before submitting!
                                </Tooltip>
                            </SubmitButton>

                            <EmailMessage>
                                * Required field<br/><br/>
                                ** Don't worry – your email won't be used for any mailing lists or marketing
                            </EmailMessage>
                            
                        
                        </Fields>
                    </Form>
                )}

                {formError && (
                    <Error
                        dangerouslySetInnerHTML={{__html: 'Sorry there was a server error. Please <a href="mailto:info@jackywinter.com">contact us</a>'}}
                    />
                )}

                {formComplete && (
                    <Thanks>
                        <p>Your pledge has been officially submitted — exciting times! Thank you so much for your support.</p> 
                        <p>In the meantime, why not take a look at our resources section to learn more about usage and licensing? Or let your friends and colleagues know about the Use It Or Lose It campaign!</p> 
                    </Thanks>
                 )} 

            </Wrapper>

        )
    }
}

const Wrapper = styled.div``

const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 100px;
    padding-bottom: 200px;

    ${media.tablet`
        margin-top: 0;
    `}
`

const Label = styled.div``

const Title = styled.div`
    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #4D4D4D;
    letter-spacing: 1.28px;
    line-height: 9px;
    text-transform: uppercase;
    text-align: center;
`

const DownArrow = styled(ArrowDownIcon)`
    margin: 20px 0 70px;
    width: 8px;
    height: 15px;
`

const Fields = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 350px;
`

const Field = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;

    .srv-validation-message {
        color: red;
        margin-top: -20px;
        margin-bottom: 40px;
        font-family: 'Platform-Regular';
        font-size: 11px;
        letter-spacing: 2px;
        text-transform: uppercase;
    }

    ${props => {
        if (props.margin) return css`
            margin: 40px 0 20px;
        `
    }}
`

// Select

const SelectContainer = styled.div`
    position: relative;
    margin-bottom: 38px;

    ${media.tablet`
        margin-bottom: 20px;
    `}

    ${Label} {
        display: flex;
        width: 100%;
        font-family: 'Platform-Regular';
        font-size: 11px;
        color: #807c7c;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: 4px;
    }
`

const SelectMarker = styled.div`
    position: absolute;
    right: 16px;
    top: 30px;
    transform: translateY(-50%);
    font-size: 14px;
    user-select: none;
    pointer-events: none;
    opacity: 0.3;
`

injectGlobal`
    .dropdown {
        display: flex;
        height: 36px;
        border: none;
        appearance: none;
        width: 100%;
        border-bottom: 1px solid #DADADA;
        flex: 1;
        background: none;

        border-radius: 0;

        font-family: Platform-Light;
        font-size: 16px;
        color: black;
        letter-spacing: 0.47px;

        &:focus{
            outline: none;
        }

        &, &::placeholder {
            color: black;
        }

        box-sizing: border-box;
    }
`


// Submit 

const Tooltip = styled.div`
    position: absolute;
    bottom: 0;
    background: black;
    color: white;
    opacity: 0;
    transition: opacity 0.25s ease;
    user-select: none;

    width: 200px;
    height: 110px;
    top: -120px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    padding: 0px 16px;

    font-family: 'Platform-Regular';
    font-size: 13px;
    letter-spacing: 1px;
    text-align: center;
`

const SubmitButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 50px;

    margin-top: 60px;

    background: #7ED321;
    box-shadow: 0 2px 1px 0 rgba(0,0,0,0.02);

    width: 182px;
    height: 52px;
    position: relative;
    transition: all 0.1s ease;
    border-radius: 4px;
    
    ${Label} {
        color: white; 
        font-family: 'Platform-Regular';
        font-size: 14px;
        letter-spacing: 1.28px;
        text-align: center;
        line-height: 9px;  
        margin-right: 7px;  
    }

    ${props => {
        if (props.disabled) return css`
            background: #7ed3217a;

            &:hover {
                cursor: default;

                .tooltip {
                    opacity: 1;
                }
            }
        `
    }}

    ${props => {
        if (!props.disabled) return css`
            &:hover {
                opacity: 0.8;
                box-shadow: 0 2px 1px 0 rgba(0,0,0,0);
                cursor: pointer;
            }
        `
    }}



`


const message = css`
    display: flex;
    justify-content: center;
    padding: 20px 0 200px;
    font-family: 'Platform-Regular';
    font-size: 18px;
`

const message2 = css`
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: #807c7c;
    letter-spacing: 1px;
    margin-top: 16px;
    text-align: center;
    max-width: 280px;
    margin-top: 48px;
`

const EmailMessage = styled.div`
    ${message2}
`

const Thanks = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
    p {
        ${body}
        color: #4D4D4D;
    }
    padding-bottom: 128px;
`

const Error = styled.div`
    ${message};
    padding: 0px 0 200px;
`

export default PledgeForm;



// WEBPACK FOOTER //
// ./client/modules/Pledge/PledgeForm.js